// src/hooks/useNativeAuthBridge.js
import { useEffect, useState } from "react";
import axios from "axios";
import { addAppMessageListener } from "../../bridges/appBridge";
import { useNavigate } from "react-router-dom";
// import { set } from "date-fns";
const API = process.env.REACT_APP_FASTAPI_ADS_URL;

export default function useNativeAuthBridge({ deviceToken, installationId }) {

  const navigate = useNavigate();
  const [isOK, setIsOK] = useState(false);

  // 추가: isOK를 다시 false로 리셋하는 함수
  const resetAuthOK = () => {
    setIsOK(false);
  };

  useEffect(() => {

    // 네이티브가 성공 시 호출: window.googleLoginComplete(idToken)
    window.googleLoginComplete = async (googleIdToken, email) => {
      try {
        if (!googleIdToken) {
          alert("구글 로그인 토큰이 비어 있습니다. 다시 시도해 주세요.");
          return;
        }
        // alert(googleIdToken)
        // alert(localStorage.getItem("device_token"))
        // alert(localStorage.getItem("install_id"))
        // alert(email)
        // ⚠️ 백엔드가 현재 기대하는 키 이름 유지: google_access_token
        const { data } = await axios.post(
          `${API}/ads/login/google`,
          {
            google_access_token: googleIdToken,   // 실제로는 'ID Token'일 가능성이 큼(네이티브 계약에 따름)
            email: email,
            device_token: localStorage.getItem("device_token") || null,
            installation_id: localStorage.getItem("install_id") || null,
            platform: localStorage.getItem("platform") || "unknown",
            // device_token: deviceToken || null,
            // installation_id: installationId || null,
          },
          { headers: { "Content-Type": "application/json" } }
        );

        if (data.msg) {
          alert(data.msg);
          return;
        }

        const {
          access_token,
          refresh_token,
          user = {},
        } = data || {};

        const {
          user_id: userId,
          store_business_number: storeBusinessNumber,
          // provider,
          // type,
        } = user;
        // alert(userId)
        localStorage.setItem("user_id", userId || "");
        localStorage.setItem("store_business_number", storeBusinessNumber || "");

        if (storeBusinessNumber) {
          navigate("/ads/main", { state: { storeBusinessNumber } });
        }

        // 네이티브에 저장 시도(앱 환경)
        if (window.Android?.saveToken) {
          window.Android.saveToken(access_token, refresh_token);
        }

        // 웹 환경 백업 저장
        if (access_token) {
          localStorage.setItem("access_token", access_token);
          axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;
        }
        if (refresh_token) {
          localStorage.setItem("refresh_token", refresh_token);
        }
        setIsOK(true);

        // await resumeAndRoute?.();
      } catch (err) {
        console.error("구글 로그인 처리 실패:", err);

      }
    };

    // 카카오(그대로 유지)
    window.kakaoLoginComplete = async (kakaoAccessToken, kakaoEmail) => {

      try {
        const { data } = await axios.post(
          `${API}/ads/login/kakao`,
          {
            kakao_access_token: kakaoAccessToken,
            email: kakaoEmail,
            device_token: localStorage.getItem("device_token") || "empty_token",
            installation_id: localStorage.getItem("install_id") || null,
            platform: localStorage.getItem("platform") || "unknown",
          },
          { headers: { "Content-Type": "application/json" } }
        );

        if (data.msg) {
          alert(data.msg);
          return;
        }

        const {
          access_token,
          refresh_token,
          user = {},
        } = data || {};

        const {
          user_id: userId,
          store_business_number: storeBusinessNumber,
          // provider,
          // type,
        } = user;
        // alert(userId)
        localStorage.setItem("user_id", userId || "");
        localStorage.setItem("store_business_number", storeBusinessNumber || "");
        if (storeBusinessNumber) {
          navigate("/ads/main", { state: { storeBusinessNumber } });
        }

        // 네이티브에 저장 시도(앱 환경)
        if (window.Android?.saveToken) {
          window.Android.saveToken(access_token, refresh_token);
        }

        // 웹 환경 백업 저장
        if (access_token) {
          localStorage.setItem("access_token", access_token);
          axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;
        }
        if (refresh_token) {
          localStorage.setItem("refresh_token", refresh_token);
        }
        setIsOK(true);
        // await resumeAndRoute?.();
      } catch (err) {
        console.error("카카오 로그인 처리 실패:", err);

      }
    };


    // Apple
    window.appleLoginComplete = async (appleAccessToken, appleEmail) => {

      try {
        const { data } = await axios.post(
          `${API}/ads/login/apple`,
          {
            apple_access_token: appleAccessToken,
            email: appleEmail,
            device_token: localStorage.getItem("device_token") || null,
            installation_id: localStorage.getItem("install_id") || null,
            platform: localStorage.getItem("platform") || "unknown",
          },
          { headers: { "Content-Type": "application/json" } }
        );

        if (data.msg) {
          alert(data.msg);
          return;
        }

        const {
          access_token,
          refresh_token,
          user = {},
        } = data || {};

        const {
          user_id: userId,
          store_business_number: storeBusinessNumber,
        } = user;
        localStorage.setItem("user_id", userId || "");
        localStorage.setItem("store_business_number", storeBusinessNumber || "");
        if (storeBusinessNumber) {
          navigate("/ads/main", { state: { storeBusinessNumber } });
        }

        // 네이티브에 저장 시도(앱 환경)
        if (window.Android?.saveToken) {
          window.Android.saveToken(access_token, refresh_token);
        }

        // 웹 환경 백업 저장
        if (access_token) {
          localStorage.setItem("access_token", access_token);
          axios.defaults.headers.common["Authorization"] = `Bearer ${access_token}`;
        }
        if (refresh_token) {
          localStorage.setItem("refresh_token", refresh_token);
        }
        setIsOK(true);
      } catch (err) {
        console.error("애플 로그인 처리 실패:", err);

      }
    };



    const off = addAppMessageListener((msg) => {
      if (msg?.type !== "SIGNIN_RESULT") return;

      // payload가 없을 수도 있으니 양쪽 모두 대비
      const p = msg.payload ?? msg;


      // 보기 좋게 출력용
      // const pretty = (obj) => {
      //   try { return JSON.stringify(obj, null, 2); }
      //   catch { return String(obj); }
      // };
      // const fmtTime = (ts) => ts ? new Date(ts).toLocaleString() : "-";

      if (p.provider === "google" || p.provider === "kakao" || p.provider === "apple") {
        if (p.success) {
          const googleIdToken = p.user?.uid || null;
          const kakaoAccessToken = p.user?.provider_id || null;
          const appleAccessToken = p.provider_id || null;

          const email = p.user?.email
          const kakaoEmail = p.user?.email
          const appleEmail = p.email || "";

          // 2) 공급자별로 기존 컴플리트 함수 재사용 → 서버 전송 + 토큰저장 + 라우팅
          if (p.provider === "google" && window.googleLoginComplete && googleIdToken) {
            window.googleLoginComplete(googleIdToken, email);
            return;
          }
          if (p.provider === "kakao" && window.kakaoLoginComplete && kakaoAccessToken) {
            window.kakaoLoginComplete(kakaoAccessToken, kakaoEmail);
            return;
          }
          if (p.provider === "apple" && window.appleLoginComplete && appleAccessToken) {
            window.appleLoginComplete(appleAccessToken, appleEmail);
            return;
          }


          // 토큰이 비어있으면 에러 안내


          return;
        } else {
          const lines = [
            "❌ 로그인 실패",
            // "",
            // `code    : ${p?.error_code ?? "-"}`,
            // `message : ${p?.error_message ?? "-"}`,
            // "",
            // "[payload 원본]",
            // pretty(p),
            // "",
            // "[전체 메시지]",
            // pretty(msg),
          ];
          alert(lines.join("\n"));
        }
      }
    });


    return () => {
      delete window.kakaoLoginComplete;
      delete window.googleLoginComplete;
      delete window.appleLoginComplete;
      off && off(); // 리스너 해제
      // receiveFcmToken은 부모에서 해제함
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceToken, installationId]);
  return { isOK, resetAuthOK };
}
